const LETTERS = (() => {
  const letters: string[] = [];
  // Generate A-Z
  for (let i = 0; i < 26; i++) {
    letters.push(String.fromCharCode(65 + i));
  }
  // Generate AA-ZZ
  for (let i = 0; i < 26; i++) {
    for (let j = 0; j < 26; j++) {
      letters.push(String.fromCharCode(65 + i) + String.fromCharCode(65 + j));
    }
  }
  return letters;
})();

export function rectToExcelCell(rect: { row0: number; col0: number }): string {
  const row0 = rect.row0 + 1;
  const col0 = rect.col0;

  const ltrs = LETTERS[col0];

  return `${ltrs}${row0}`;
}

export function rectToExcelRange(rect: {
  row0: number;
  row1: number;
  col0: number;
  col1: number;
}): string {
  const row0 = rect.row0 + 1;
  const row1 = rect.row1 + 1;
  const col0 = rect.col0;
  const col1 = rect.col1;

  const ltrs = LETTERS[col0];
  const ltrs1 = LETTERS[col1];

  return `${ltrs}${row0}:${ltrs1}${row1}`;
}
